<div class="flex justify-end full-width">
    <label class="p2 bold lvl2 flex align-center checkbox">
        <span><ng-content></ng-content></span>
        <input type="checkbox"
               [disabled]="disabled"
               [(ngModel)]="checked"
               (change)="onCheckboxClick()">

        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.612 1.29175H5.38783C2.87033 1.29175 1.29199 3.07425 1.29199 5.59675V12.4034C1.29199 14.9259 2.86283 16.7084 5.38783 16.7084H12.6112C15.137 16.7084 16.7087 14.9259 16.7087 12.4034V5.59675C16.7087 3.07425 15.137 1.29175 12.612 1.29175Z"
                  stroke="#232323" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.0332 8.99996L8.01154 10.9775L11.9665 7.02246" stroke="#232323" stroke-width="1.5"
                  stroke-linecap="round" stroke-linejoin="round" id="checkmark-path" [class.checked]="checked"/>
        </svg>
    </label>
</div>
